export default "/signup/_next/static/chunks/fonts/Otella-4b374021e9bb701450d42a85ae987d57.ttf";